import React from 'react';

interface CustomCellsProps {
  children: React.ReactNode;
}

const CustomCells = ({ children }: CustomCellsProps) => (
  <>
    {children}
  </>
);

export default CustomCells;
